import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Auth.css';
import { completePasswordlessSignIn } from '../firebase';
import sonoranLandscape from '../assets/images/dither-yosemite.jpg';

const ConfirmEmailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const emailLink = location.state?.emailLink || null;
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    // Use the link we stored when redirecting here (user opened link on different device)
    const result = await completePasswordlessSignIn(email, emailLink);

    if (result.success) {
      navigate('/profile');
    } else if (result.error) {
      setError(result.error.message || 'Failed to complete sign-in. Please try again.');
    } else {
      setError('This sign-in link is invalid or has expired. Please request a new link from the login page.');
    }
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-form-wrapper">
        <h2 className="auth-title">CONFIRM YOUR EMAIL</h2>
        <p className="auth-message info">
          For security reasons, please confirm your email address to complete sign-in.
        </p>
        {error && <p className="auth-message error">{error}</p>}
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-input-group">
            <label htmlFor="email">EMAIL ADDRESS</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required 
              disabled={loading}
              placeholder="Enter the email you signed up with"
              autoFocus
            />
          </div>
          <button type="submit" className="auth-button primary" disabled={loading}>
            {loading ? 'VERIFYING...' : 'CONFIRM & CONTINUE'}
          </button>
        </form>
      </div>
      <div className="auth-image-wrapper">
        <img src={sonoranLandscape} alt="Desert landscape" />
      </div>
    </div>
  );
};

export default ConfirmEmailPage;

